import React, { useState, useEffect } from "react";
import { Music } from "lucide-react";
import { Button } from "@/src/components/ui/button.tsx";
import { API_ENDPOINTS } from "@/src/config/api.js";

const MixOfTheWeek = () => {
    const [motw, setMotw] = useState(null);

    useEffect(() => {
        fetch(API_ENDPOINTS.messageBoard.motw)
            .then(response => response.json())
            .then(data => setMotw(data))
            .catch(error => console.error("Error fetching Mix of the Week:", error));
    }, []);

    if (!motw) return null;

    return (
        <div className="bg-neutral-900 rounded-lg p-4">
            <h2 className="font-bold text-lg mb-4">MIX OF THE WEEK</h2>
            <div className="grid grid-cols-1 gap-3 mb-6">
                <div className="flex flex-col group cursor-pointer">
                    <div className="relative">
                        <a href={motw.url} target="_blank">
                            <img
                                src={`https://dreamchimney.com/motw/img/mixes-new/${motw["motw-series-number"]}.jpg`}
                                alt={`Mix of the Week ${motw["motw-series-number"]} - ${motw.title}`}
                                className="w-full aspect-square object-cover rounded-md group-hover:opacity-75 transition-opacity"
                            />
                            <Button
                                size="icon"
                                className="absolute bottom-2 right-2 bg-white text-black hover:bg-gray-200 rounded-full w-8 h-8 opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                                <Music className="h-4 w-4" />
                            </Button>
                        </a>
                    </div>
                    <a href={motw.url} target="_blank" className="no-underline">
                        <h3 className="text-lg font-bold mt-4 truncate">Mix #{motw["motw-series-number"]} - {motw.dj}</h3>
                        <p className="text-base text-gray-400 truncate">{motw.title}</p>
                        <p className="text-xs text-gray-500 mt-1">Tags: {motw.tags.replace(/,/g, ', ')}</p>
                    </a>
                </div>
            </div>
            {/* <div className="text-center">
                <a href="/motw" variant="outline" size="sm" className="no-underline bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-xs w-full">
                    More Mixes of the Week
                </a>
            </div> */}
        </div>
    );
};

export default MixOfTheWeek; 